// import React from "react";
// import html2canvas from "html2canvas";
// import { jsPDF } from "jspdf";
// import QRCode from "qrcode";

// import { v4 as uuidv4 } from "uuid";

// export default function CertificateDownloadButton({
//   user,
//   course,
//   issuer,
//   disabled,
// }) {
//   const downloadPDF = async () => {
//     const certId = `CERT-${uuidv4()}`;
//     const issueDate = new Date().toLocaleDateString();

//     // Temporary off-screen div
//     const tempDiv = document.createElement("div");
//     tempDiv.style.width = "297mm";
//     tempDiv.style.height = "210mm";
//     tempDiv.style.padding = "50px";
//     tempDiv.style.boxSizing = "border-box";
//     tempDiv.style.fontFamily = "'Times New Roman', serif";
//     tempDiv.style.background = "#fdf6e3"; // light cream background
//     tempDiv.style.border = "15px solid #c0a16b";
//     tempDiv.style.borderRadius = "15px";
//     tempDiv.style.position = "relative";
//     tempDiv.style.backgroundImage = `url("/images/certificate-watermark.png")`;
//     tempDiv.style.backgroundSize = "cover";
//     tempDiv.style.backgroundPosition = "center";
//     tempDiv.style.boxShadow = "0 0 30px rgba(0,0,0,0.2)";
//     tempDiv.style.textAlign = "center";
//     tempDiv.style.color = "#333";

//     // Canva-style HTML content
//     tempDiv.innerHTML = `
//     <h1 style="font-size:50px; font-weight:bold; margin-bottom:10px; color:#b17e32;">Certificate of Completion</h1>
//     <p style="font-size:20px; margin-bottom:25px;">This is to certify that</p>
//     <h2 style="font-size:40px; font-weight:bold; margin-bottom:25px; color:#4b3a2f;">${
//       user.firstName + " " + user.lastName
//     }</h2>
//     <p style="font-size:20px; margin-bottom:25px;">has successfully completed the course</p>
//     <h3 style="font-size:32px; font-style:italic; margin-bottom:50px; color:#6b4f3b;">${course}</h3>
//     <p style="font-size:18px; margin-bottom:50px;">Issued by ${"Affiliate Ritual"}</p>

//     <div style="display:flex; justify-content:space-between; align-items:flex-end; margin-top:50px;">
//       <div style="text-align:center;">
//         <img src="/images/signature.png" alt="signature" style="height:60px;"/>
//         <div style="margin-top:5px; font-size:14px;">Instructor Signature</div>
//       </div>
//       <div id="qrContainer" style="text-align:center; display:flex; flex-direction:column; align-items:center;">
//         <div style="margin-top:5px; font-size:12px;">Certificate ID: ${certId}</div>
//       </div>
//     </div>

//     <div style="position:absolute; bottom:40px; left:50px; font-size:14px;">Issued on: ${issueDate}</div>
//   `;

//     // Append temporarily to body
//     document.body.appendChild(tempDiv);

//     // Generate QR code in the QR container
//     const qrContainer = tempDiv.querySelector("#qrContainer");
//     const qrCanvas = document.createElement("canvas");
//     await QRCode.toCanvas(qrCanvas, JSON.stringify({ certId }), { width: 100 });
//     qrContainer.prepend(qrCanvas);

//     // Render the certificate to canvas
//     const canvas = await html2canvas(tempDiv, { scale: 3, useCORS: true });
//     const imgData = canvas.toDataURL("image/jpeg", 0.95);

//     // Clean up
//     document.body.removeChild(tempDiv);

//     // Generate PDF
//     const pdf = new jsPDF("landscape", "mm", "a4");
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
//     pdf.save(
//       `${user.firstName + " " + user.lastName}-${course}-certificate.pdf`
//     );
//   };
//   return (
//     <button
//       onClick={downloadPDF}
//       disabled={disabled}
//       className={`w-full px-8 py-2 text-sm font-medium rounded-md mb-2 transition-opacity duration-200
//     ${
//       disabled
//         ? "bg-gray-400 cursor-not-allowed text-white"
//         : "bg-gradient-to-r from-[#B17E32] via-[#F3E681] to-[#CF9F41] text-black hover:opacity-90 cursor-pointer"
//     }`}
//     >
//       {disabled ? "Complete Course to Download" : "Download Certificate"}
//     </button>
//   );
// }
// import React from "react";
// import html2canvas from "html2canvas";
// import { jsPDF } from "jspdf";
// import QRCode from "qrcode";
// import { v4 as uuidv4 } from "uuid";

// export default function CertificateDownloadButton({
//   user,
//   course,
//   issuer,
//   disabled,
// }) {
//   const downloadPDF = async () => {
//     const certId = `CERT-${uuidv4()}`;
//     const issueDate = new Date().toLocaleDateString();

//     // Temporary off-screen div
//     const tempDiv = document.createElement("div");
//     tempDiv.style.width = "297mm";
//     tempDiv.style.height = "210mm";
//     tempDiv.style.position = "relative";
//     tempDiv.style.boxSizing = "border-box";

//     // Background image (your uploaded template)
//     tempDiv.style.background = `url("/Gemini_Generated_Image_4vvtxe4vvtxe4vvt.png") no-repeat center`;
//     tempDiv.style.backgroundSize = "cover";

//     // Overlay content
//     tempDiv.innerHTML = `
//       <div style="
//         width: 100%;
//         height: 100%;
//         padding: 120px 80px;
//         text-align: center;
//         font-family: 'Times New Roman', serif;
//         position: relative;
//         color: #333;
//       ">

//         <p style="font-size:16px; margin-bottom:15px;">This certificate is proudly presented to</p>

//         <h2 style="
//           font-size:46px;
//           font-family: 'Brush Script MT', cursive;
//           color:#b17e32;
//           margin-bottom:25px;
//         ">
//           ${user.firstName} ${user.lastName}
//         </h2>

//         <p style="max-width:650px; margin: 0 auto 30px; font-size:14px; line-height:1.5;">
//           For successfully completing the <b>${course}</b> course and demonstrating
//           outstanding performance.
//         </p>

//         <div style="margin-top:40px; display:flex; justify-content:space-between; align-items:center;">
//           <div style="text-align:center;">
//             <img src="/images/signature.png" alt="signature" style="height:60px;" />
//             <div style="font-size:14px; margin-top:5px;">${
//               issuer || "Supervisor"
//             }</div>
//           </div>
//           <div id="qrContainer" style="text-align:center; display:flex; flex-direction:column; align-items:center;">
//             <div style="margin-top:5px; font-size:12px;">Certificate ID: ${certId}</div>
//           </div>
//         </div>

//         <div style="position:absolute; bottom:40px; left:50px; font-size:14px;">
//           Issued on: ${issueDate}
//         </div>
//       </div>
//     `;

//     // Append temporarily to body
//     document.body.appendChild(tempDiv);

//     // Generate QR code inside qrContainer
//     const qrContainer = tempDiv.querySelector("#qrContainer");
//     const qrCanvas = document.createElement("canvas");
//     await QRCode.toCanvas(qrCanvas, JSON.stringify({ certId }), { width: 90 });
//     qrContainer.prepend(qrCanvas);

//     // Render the certificate to canvas
//     const canvas = await html2canvas(tempDiv, { scale: 3, useCORS: true });
//     const imgData = canvas.toDataURL("image/jpeg", 0.95);

//     // Clean up
//     document.body.removeChild(tempDiv);

//     // Generate PDF
//     const pdf = new jsPDF("landscape", "mm", "a4");
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
//     pdf.save(
//       `${user.firstName + " " + user.lastName}-${course}-certificate.pdf`
//     );
//   };

//   return (
//     <button
//       onClick={downloadPDF}
//       disabled={disabled}
//       className={`w-full px-8 py-2 text-sm font-medium rounded-md mb-2 transition-opacity duration-200
//     ${
//       disabled
//         ? "bg-gray-400 cursor-not-allowed text-white"
//         : "bg-gradient-to-r from-[#B17E32] via-[#F3E681] to-[#CF9F41] text-black hover:opacity-90 cursor-pointer"
//     }`}
//     >
//       {disabled ? "Complete Course to Download" : "Download Certificate"}
//     </button>
//   );
// }
import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import QRCode from "qrcode";
import { v4 as uuidv4 } from "uuid";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebase-config";
export default function CertificateDownloadButton({
  user,
  course,
  issuer,
  disabled,
  courseId,
  certificateDate,
}) {
  const addCertificateRecord = async (userId, buyItemId) => {
    try {
      const userRef = doc(db, "users", userId);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        console.error("User not found");
        return;
      }

      const userData = userSnap.data();

      // Use or create certificateRecords object
      const certificateRecords = userData.certificateRecords || {};
      // If certificate already exists, skip
      if (certificateRecords[buyItemId]) {
        return;
      }
      // Add new certificate entry with current date
      certificateRecords[buyItemId] = {
        completionDate: new Date().toISOString(), // store as ISO string
      };
      await updateDoc(userRef, { certificateRecords });
      console.log("Certificate record added successfully!");
    } catch (error) {
      console.error("Error adding certificate record:", error);
    }
  };

  const downloadPDF = async () => {
    const certId = `CERT-${uuidv4()}`;
    const issueDate = new Date().toLocaleDateString();

    // Temporary off-screen div
    const tempDiv = document.createElement("div");
    tempDiv.style.width = "297mm";
    tempDiv.style.height = "210mm";
    tempDiv.style.position = "relative";
    tempDiv.style.boxSizing = "border-box";

    // Background image (template)
    tempDiv.style.background = `url("/Gemini_Generated_Image_4vvtxe4vvtxe4vvt.png") no-repeat center`;
    tempDiv.style.backgroundSize = "cover";

    // Overlay content
    tempDiv.innerHTML = `
  <div style="
    width: 100%;
    height: 100%;
    padding: 150px 100px 60px 450px;
    font-family: 'Times New Roman', serif;
    position: relative;
    color: #333;
    box-sizing: border-box;
  ">

    <!-- Header -->
    <h1 style="
      font-size: 48px;
      font-weight: bold;
      margin: 0;
      text-align: center;
      color: #b17e32;
    ">
      Certificate of Completion
    </h1>

    <!-- Subtitle -->
    <p style="font-size: 16px; margin: 20px 0; text-align:center;">
      This certificate is proudly presented to
    </p>

    <!-- Recipient name -->
    <h2 style="
      font-size: 40px;
      font-family: 'Brush Script MT', cursive;
      color: #b17e32;
      margin: 10px 0 20px 0;
      text-align: center;
    ">
      ${user.firstName} ${user.lastName}
    </h2>

    <!-- Course / message -->
    <p style="
      max-width: 600px;
      margin: 0 auto 40px auto;
      font-size: 16px;
      line-height: 1.5;
      text-align: center;
    ">
      For successfully completing the <b>${course}</b> course and demonstrating
      outstanding performance.
    </p>

    <!-- Footer: signature + QR -->
    <div style="
      width: 100%;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    ">
      <!-- Signature + date -->
      <div style="display:flex; flex-direction:column; align-items:center;">
  <img src="/signature.png" alt="signature" style="height:50px;" />
  <div style="font-size:14px;">
    ${issuer || "Authoriser"}
  </div>
  <div style="font-size:14px; ">
    Issued on: ${certificateDate ? certificateDate : issueDate}
  </div>
</div>
      <!-- QR code -->
      <div id="qrContainer" style="text-align:center; display:flex; flex-direction:column; align-items:center;">
        <div style="margin-top:5px; font-size:12px;">Certificate ID: ${certId}</div>
      </div>
    </div>
  </div>
`;

    // Append temporarily to body
    document.body.appendChild(tempDiv);

    // Generate QR code inside qrContainer
    const qrContainer = tempDiv.querySelector("#qrContainer");
    const qrCanvas = document.createElement("canvas");
    await QRCode.toCanvas(qrCanvas, JSON.stringify({ certId }), { width: 90 });
    qrContainer.prepend(qrCanvas);

    // Render the certificate to canvas
    const canvas = await html2canvas(tempDiv, { scale: 3, useCORS: true });
    const imgData = canvas.toDataURL("image/jpeg", 0.95);

    // Clean up
    document.body.removeChild(tempDiv);

    // Generate PDF
    const pdf = new jsPDF("landscape", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(
      `${user.firstName + " " + user.lastName}-${course}-certificate.pdf`
    );
  };

  return (
    <button
      onClick={async () => {
        await downloadPDF();
        await addCertificateRecord(user.uid, courseId);
      }}
      disabled={disabled}
      className={`w-full px-8 py-2 text-sm font-medium rounded-md mb-2 transition-opacity duration-200
  ${
    disabled
      ? "bg-gray-400 cursor-not-allowed text-white"
      : "bg-gradient-to-r from-[#B17E32] via-[#F3E681] to-[#CF9F41] text-black hover:opacity-90 cursor-pointer"
  }`}
    >
      {disabled ? "Complete Course to Download" : "Download Certificate"}
    </button>
  );
}
